import { calculateAbweichung } from '@/utils/helperFunctions';
import { ArbeitsbereichCellContent } from '../cells/ArbeitsbereichCell';
import {
  ArbeitszeitCellArbeitszeitContent,
  ArbeitszeitCellContentAbwesenheit,
} from '../cells/ArbeitszeitCell';
import { KonfliktWrapper } from '../cells/KonfliktWrapper';
import { MitarbeiterContent } from '../cells/MitarbeiterCell';
import { RowTypeMap } from '../entities/Entities';
import { CellRenderers } from './renderer';
import { DauerCellContent } from '../cells/DauerCell';
import { HinweiseCellContent } from '../cells/HinweiseCell';
import { Abwesenheit } from '../entities/Abwesenheit';
import { Arbeitszeit } from '../entities/Arbeitszeit';

import { KonfliktActionWrapper } from '@/domain/arbeitszeiten/components/Table/ToDoTable/cells/KonfliktActionCellWrapper';
import { Popover, PopoverContent, PopoverTrigger } from '@e2n/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDoNotEnter } from '@fortawesome/pro-regular-svg-icons';
import { t } from 'i18next';

const konfliktRenderer: CellRenderers<RowTypeMap['konflikt']> = {
  name: (row) => (
    <KonfliktWrapper
      root={
        <MitarbeiterContent mitarbeiter={row.rootArbeitszeit.mitarbeiter} />
      }
      cause={
        row.conflictCause !== null ? (
          <MitarbeiterContent mitarbeiter={row.rootArbeitszeit.mitarbeiter} />
        ) : (
          ''
        )
      }
    />
  ),
  arbeitsbereich: (row) => (
    <KonfliktWrapper
      root={
        <ArbeitsbereichCellContent
          arbeitsbereich={row.rootArbeitszeit.arbeitsbereich}
        />
      }
      cause={
        row.conflictCause !== null ? (
          <ArbeitsbereichCellContent
            arbeitsbereich={row.conflictCause.arbeitsbereich}
          />
        ) : (
          ''
        )
      }
    />
  ),
  // eslint-disable-next-line max-lines-per-function
  arbeitszeit: (row) => (
    <KonfliktWrapper
      root={
        row.rootArbeitszeit instanceof Arbeitszeit ? (
          <ArbeitszeitCellArbeitszeitContent
            beginn={row.rootArbeitszeit.beginn}
            kommen={row.rootArbeitszeit.kommen}
            ende={row.rootArbeitszeit.ende}
            gehen={row.rootArbeitszeit.gehen}
            pausenDauer={row.rootArbeitszeit.getPausendauer()}
            id={row.rootArbeitszeit.id}
            pausen={row.rootArbeitszeit.pausen}
          />
        ) : (
          <ArbeitszeitCellContentAbwesenheit
            abwesenheit={row.rootArbeitszeit}
          />
        )
      }
      cause={
        row.conflictCause === null ? (
          <>
            <p className="text-primary-red-500  text-center hidden md:block">
              {t('domain.arbeitszeiten.uebersicht.fehlendeRechte')}
            </p>
            <Popover>
              <PopoverTrigger className="md:hidden" asChild>
                <FontAwesomeIcon
                  icon={faDoNotEnter}
                  className="text-primary-red-500"
                  size="lg"
                />
              </PopoverTrigger>
              <PopoverContent className="w-48 wrap-normal">
                <p>{t('domain.arbeitszeiten.uebersicht.fehlendeRechte')}</p>
              </PopoverContent>
            </Popover>
          </>
        ) : (
          <>
            {row.conflictCause instanceof Abwesenheit && (
              <ArbeitszeitCellContentAbwesenheit
                abwesenheit={row.conflictCause}
              />
            )}
            {row.conflictCause instanceof Arbeitszeit && (
              <ArbeitszeitCellArbeitszeitContent
                beginn={row.conflictCause.beginn}
                kommen={row.conflictCause.kommen}
                ende={row.conflictCause.ende}
                gehen={row.conflictCause.gehen}
                pausenDauer={row.conflictCause.getPausendauer()}
                id={row.conflictCause.id}
                pausen={row.conflictCause.pausen}
              />
            )}
          </>
        )
      }
    />
  ),
  dauer: (row) => {
    let abweichungRoot = undefined;
    if (
      row.rootArbeitszeit instanceof Arbeitszeit &&
      row.rootArbeitszeit.beginn &&
      row.rootArbeitszeit.ende
    ) {
      abweichungRoot = calculateAbweichung(
        row.rootArbeitszeit.beginn.abweichung,
        row.rootArbeitszeit.ende.abweichung,
      );
    }

    return (
      <KonfliktWrapper
        cause={
          row.conflictCause !== null ? (
            <DauerCellContent dauer={row.conflictCause.dauer} />
          ) : (
            ''
          )
        }
        root={
          row.rootArbeitszeit instanceof Arbeitszeit ? (
            <DauerCellContent
              dauer={row.rootArbeitszeit.dauer}
              abweichung={abweichungRoot}
            />
          ) : (
            <DauerCellContent dauer={row.rootArbeitszeit.dauer} />
          )
        }
      />
    );
  },
  hinweise: (row) => (
    <KonfliktWrapper
      root={
        row.rootArbeitszeit instanceof Arbeitszeit ? (
          <HinweiseCellContent
            rechtshinweise={row.rootArbeitszeit.rechtshinweise}
            zuschlaege={row.rootArbeitszeit.zuschlaege}
            termin={row.rootArbeitszeit.termin}
            bemerkung={row.rootArbeitszeit.bemerkung}
          />
        ) : (
          ''
        )
      }
      cause={
        row.conflictCause === null ? (
          ''
        ) : (
          <>
            {row.conflictCause instanceof Arbeitszeit && (
              <HinweiseCellContent
                rechtshinweise={row.conflictCause.rechtshinweise}
                zuschlaege={row.conflictCause.zuschlaege}
                termin={row.conflictCause.termin}
                bemerkung={row.conflictCause.bemerkung}
              />
            )}
          </>
        )
      }
    />
  ),
  action: (row) => <KonfliktActionWrapper konflikt={row} />,
};

export default konfliktRenderer;
